import React from 'react';
import { Typography } from '@utex/ui-kit';
import { useTranslation } from 'react-i18next';
import { AbroadBankDepositDetails } from '../../hooks/useBankDetails/index.types';
import { Item } from './components/Item';
import { Container, Section } from './styles';

export const Details: React.FC<AbroadBankDepositDetails> = (props) => {
  const { t } = useTranslation('byBank');
  const [firstPartPurposeOfPayment, secondPartPurposeOfPayment] = props.purposeOfPayment.split('.');

  return (
    <Container>
      <Section>
        <Item title={t('Bank')} value={props.bankName} />
        <Item title={t('SWIFT')} value={props.swift} />
        <Item title={t('Address of the Bank')} value={props.bankAddress} />
      </Section>

      <Section>
        {props.intermediaryBankName && (
          <Item title={t('Corresp bank')} value={props.intermediaryBankName} />
        )}
        {props.intermediarySwift && <Item title={t('SWIFT')} value={props.intermediarySwift} />}
        {props.correspondentAccount && (
          <Item title={t('Account')} value={props.correspondentAccount} />
        )}
      </Section>

      <Section>
        <Item title={t('Recipient')} value={props.recipient} />
        <Item title={t('Beneficiary account')} value={props.accountOfReceiver} />
        <Item title={t('Address')} value={props.recipientAddress} />
        <Item
          title={t('Purpose of payment')}
          value={
            <>
              {`${firstPartPurposeOfPayment}. `}
              <Typography.Text size="S" weight="bold">
                {secondPartPurposeOfPayment}
              </Typography.Text>
            </>
          }
          valueForCopy={props.purposeOfPayment}
        />
      </Section>
    </Container>
  );
};
